import axios, { type AxiosError } from 'axios';

import { getBeErrorMessage } from '~/common/utils/getBeErrorMessage';

type AuthErrorBody = { readonly message?: unknown; readonly error?: unknown };

// The concrete shape the identity service sends
export type AuthErrorResponseBody = {
  readonly message?: string;
  readonly error?: string;
  readonly showSupportCTA?: boolean;
  readonly showBeMessage?: boolean;
};

// react-query hands onError whatever was thrown: identity rejects with an AxiosError, but a throw
// inside mutationFn (a sessionStorage quota error, a malformed-200 destructure) arrives as a plain Error
export type AuthMutationError = AxiosError<AuthErrorResponseBody> | Error;

export const resolveAuthErrorMessage = (
  error: unknown,
  fallback: string,
  rawOn401ErrorCodes: readonly string[] = []
): string | undefined => {
  const beMessage = getBeErrorMessage(error);
  if (beMessage) return beMessage;

  const response = axios.isAxiosError<AuthErrorBody>(error) ? error.response : undefined;
  const status = response?.status;
  const body = response?.data;

  const showsRawMessage =
    status !== 401 || (typeof body?.error === 'string' && rawOn401ErrorCodes.includes(body.error));

  if (showsRawMessage) return typeof body?.message === 'string' ? body.message : undefined;

  return fallback;
};
